import { render, staticRenderFns } from "./VesselComunication.vue?vue&type=template&id=b4d8c18e&scoped=true"
import script from "./VesselComunication.vue?vue&type=script&lang=js"
export * from "./VesselComunication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d8c18e",
  null
  
)

export default component.exports